

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import { Typography } from '@material-ui/core';
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';

const styles =({
  root: {
    position: 'relative',
    maxWidth: '100vw',
    borderRadius: 0,
    cursor: 'pointer'
  },

  para: {
    '& p': {
        fontFamily: 'DuwunFont',
        color: '#fff',
        background: '#282828',
        fontSize: 14,
        overflowWrap: 'break-word'
    }
  },
  titleStyle: {
    padding: 14
  },
  descriptionStyle: {
    padding: '0px 14px 14px',
    maxHeight: 200,
    overflowY: 'scroll'
  }
  
});

function GalleryCarouselItem(props) {
  const { classes, item, items, index, active } = props;
  return (
    <Card className={classes.root} onClick={() => active(index, items)}>
          {/* <img src="https://www.dw.com/image/47531493_302.jpg" style={{ objectFit: 'contain' }} alt='image' /> */}
          <img src={item.cover.thumb} style={{ objectFit: 'contain', height: 259, width: '100%' }} alt='image' />

        <div className={classes.para}>
        <Typography className={classes.titleStyle} component="p" variant="subtitle1">
            {fontUniOrConvertZawgyi(item.name)}
        </Typography>
        <Typography className={classes.descriptionStyle} component="p" variant="subtitle1" id="scrollbarStyle">
            {fontUniOrConvertZawgyi(item.description)}
        </Typography>
        </div>
    </Card>
  );
}
export default withStyles(styles)(GalleryCarouselItem);
